import { useAction } from "./useAction";
import { CotaUsuario } from "../interfaces/CotaUsuario";
import { cadastrarCotaUsuarioService } from "../services/cadastrarCotaUsuario";

export const useCadastrarCotaUsuario = () => {
  const {
    execute: cadastrarCotaUsuario,
    isLoading,
    data,
    error,
    success,
  } = useAction<CotaUsuario>(cadastrarCotaUsuarioService);

  const handleSubmit = async (cotaUsuario: CotaUsuario) => {

    console.log("CotaUsuario a ser cadastrada:", cotaUsuario);
    try {
      const response = await cadastrarCotaUsuario(cotaUsuario);
      console.log("CotaUsuario cadastrada com sucesso", response);
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar cota", error);
      throw error; // propaga erro para quem chamou
    }
  };

  return {
    handleSubmit,
    isLoading,
    data,
    error,
    success,
  };
};
